import { Center, Divider, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const BloodPressureLegendModal = () => {
  const { t } = useTranslation();

  return (
    <>
      <Divider
        my={'xs'}
        label={t('systolic_label')}
        size={'md'}
        color={'var(--mantine-color-blue-5)'}
        labelPosition={'center'}
      />
      <Divider
        my={'xs'}
        label={t('average_systolic_label')}
        size={'xs'}
        color={'var(--mantine-color-red-5)'}
        labelPosition={'center'}
      />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-1'} labelPosition={'center'} />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-1'} labelPosition={'center'} />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-1'} labelPosition={'center'} />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-1'} labelPosition={'center'} />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-1'} labelPosition={'center'} />
      <Text mb={'lg'}>
        <Center>{t('normal_systolic_label')}</Center>
      </Text>
      <Divider
        my={'xs'}
        label={t('diastolic_label')}
        size={'md'}
        color={'var(--mantine-color-blue-5)'}
        labelPosition={'center'}
      />
      <Divider
        my={'xs'}
        label={t('average_diastolic_label')}
        size={'xs'}
        color={'var(--mantine-color-red-5)'}
        labelPosition={'center'}
      />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-3)'} labelPosition={'center'} />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-3)'} labelPosition={'center'} />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-3)'} labelPosition={'center'} />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-3)'} labelPosition={'center'} />
      <Divider size={'xl'} color={'var(--mantine-color-turquoise-3)'} labelPosition={'center'} />
      <Text mb={'sm'}>
        <Center>{t('normal_diastolic_label')}</Center>
      </Text>
    </>
  );
};
